import { useEffect, useState } from 'react';

function useScrollY(elementId?: string) {
  const [y, setY] = useState<number>(0);

  useEffect(() => {
    const scrollElement =
      elementId === 'body'
        ? document.body
        : elementId
        ? document.getElementById(elementId) || window
        : window;

    function handleScroll() {
      let scrollY;
      if (scrollElement instanceof Window) {
        scrollY = window.scrollY || window.pageYOffset;
      } else if (
        scrollElement === document.documentElement ||
        scrollElement === document.body
      ) {
        scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      } else {
        scrollY = scrollElement.scrollTop;
      }
      // console.log('scrollY:', scrollY); // Debugging purpose
      setY(Math.round(scrollY));
    }

    scrollElement.addEventListener('scroll', handleScroll);

    return () => scrollElement.removeEventListener('scroll', handleScroll);
  }, [elementId]);

  return y;
}

export default useScrollY;
